import SashiDo from 'lib/SashiDo';
import React from 'react';
import PropTypes from 'prop-types';

import history from 'dashboard/history';
import Gravatar from 'react-gravatar';
import Tooltip from 'rc-tooltip';

import AccountManager from 'lib/AccountManager';
import ParseApp from 'lib/ParseApp';

import TeamDesk from 'components/TeamDesk/TeamDesk.react';
import Icon from 'components/Icon/Icon.react';
import styles from './SidebarUserMenu.scss';

export default class SidebarUserMenu extends React.Component {
  constructor() {
    super();
    this.state = {
      isUserMenuOpen: false,
      isTeamDeskOpen: false,
    };
  }

  componentDidMount() {
    AccountManager.currentUser().then(({ currentUser }) => {
      this.setState({ currentUser });
    });
    document.body.addEventListener('click', this.handleUserMenuClose);
  }

  componentWillReceiveProps() {
    this.setState({
      isTeamDeskOpen: false,
    });
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.handleUserMenuClose);
  }

  handleGoToURLClick = url => (e) => {
    e.preventDefault();
    history.push(url);
  }

  handleLogOut = () => {
    SashiDo.logOut(true);
  }

  handleTeamDeskOpen = () => {
    this.setState({ isTeamDeskOpen: true, isUserMenuOpen: false });
  }

  handleUserMenuClick = () => {
    this.setState({
      isUserMenuOpen: !this.state.isUserMenuOpen,
      isTeamDeskOpen: false,
    });
  }

  render() {
    const { currentUser } = this.state;

    if (!currentUser) return null;

    const currentUsername = currentUser.email.length > 20 ? `${currentUser.email.substring(0, 20)}...` : currentUser.email;

    return (
      <div className={[styles.footer, this.state.isUserMenuOpen ? styles.show : null].join(' ')}>
        <div className={styles.holder} onClick={this.handleUserMenuClick}>
          <span className={styles.avatar}>
            {
              currentUser.use_gravatar || !currentUser.image
                ? <Gravatar email={currentUser.email} size={100} default="mm" />
                : <img src={currentUser.image} alt={currentUser.email} />
            }
          </span>
          <h2>
            <span>{currentUsername}</span>
          </h2>
        </div>

        <div className={styles.teamDesk} onClick={this.handleTeamDeskOpen}>
          <Tooltip placement="top" overlay="Open a Ticket" arrowContent={<div className="rc-tooltip-arrow-inner" />}>
            <span>
              <Icon name="icon-teamdesk" width={24} height={24} colored />
            </span>
          </Tooltip>

          <TeamDesk open={this.state.isTeamDeskOpen} />
        </div>

        <div className={styles.userMenu}>
          <a href="/products/apps" className={styles.item} onClick={this.handleGoToURLClick('/products/apps')}>Your Apps</a>
          <div className={styles.separator} />
          <a href="/billing/info" className={styles.item} onClick={this.handleGoToURLClick('/billing/info')}>Billing</a>
          <div className={styles.separator} />
          <a href="/account/info" className={styles.item} onClick={this.handleGoToURLClick('/account/info')}>Account</a>
          <div className={styles.separator} />
          <a href="/referrals" className={styles.item} onClick={this.handleGoToURLClick('/referrals')}>Referrals</a>
          <div className={styles.separator} />
          <a href="https://parseplatform.github.io/" className={styles.item} target="_blank" rel="noreferrer noopener">Parse Open Source Docs</a>
          <div className={styles.separator} />
          <a href="https://blog.sashido.io/tag/tutorial/" className={styles.item} target="_blank" rel="noreferrer noopener">SashiDo Tutorials</a>
          <div className={styles.separator} />
          <a href="/login" className={styles.item} onClick={this.handleLogOut}>Log Out</a>
        </div>
      </div>
    );
  }
}

SidebarUserMenu.contextTypes = {
  currentApp: PropTypes.instanceOf(ParseApp),
};
